import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WindowService } from '@core/window-actions';
import { Layout } from '@store/global/types/layout-theme.enum';

import { Button } from './button.model';

@Component({
  selector: 'jb-button',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  buttons: Button[];
  layoutEnum = Layout;
  alignment: string;

  constructor(public windowService: WindowService) {}
}

export const buttonResolver = (registry, data) => {
  return { buttons: data.button, alignment: data.button[0]?.alignment };
};
